import logo from '../images/BF_Logo_Banner.png';
import {Customization} from '@eduvision/toolkit';

export const Logo: Customization['Logo'] = {
  imageSrc: logo
};
